import axios from 'axios'
import router from '../router'
import store from '@/store'
const connection = axios.create({
  baseURL: process.env.API_ROOT,
  timeout: 10000
})
// http request 请求拦截器，有token值则配置上token值
connection.interceptors.request.use(
  config => {
    if (store.state.token || JSON.parse(localStorage.getItem('turingToken'))) {
      let token = store.state.token || JSON.parse(localStorage.getItem('turingToken')).data
      config.headers.Authorization = token
      // var data = localStorage.getItem('turingToken')
      // var dataObj = JSON.parse(data)
      // if (new Date().getTime() - dataObj.time > 1000 * 60) {
      //   router.replace('/')
      // }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })
connection.interceptors.response.use(function (response) {
  switch (response.data.code) {
    case 30001:
      localStorage.removeItem('turingToken')
      // 30001 清除token信息并跳转到登录页面
      let url = process.env.NODE_ENV !== 'production' ? encodeURIComponent('http://www.beta.turingapi.com/loading') : encodeURIComponent('http://www.turingapi.com/loading')
      let appId = process.env.APP_ID
      window.location = `https://open.weixin.qq.com/connect/qrconnect?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_login#wechat_redirect`
      return
    case 30002:
      // 30002 手机绑定页
      router.replace('/login')
  }
  return response
})

export default connection



// WEBPACK FOOTER //
// ./src/api/ajax.js